import { render, staticRenderFns } from "./IncrementalDocumentUpload.vue?vue&type=template&id=6b505bc4&"
import script from "./IncrementalDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./IncrementalDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./IncrementalDocumentUpload.vue?vue&type=style&index=0&id=6b505bc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports